// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-section {
  padding: 60px 20px;
  text-align: center;
  max-width: 1200px;
  margin: auto;
}

.team-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  gap: 10px;
}

.team-header .line {
  flex: 1 1;
  height: 3px;
  background-color: #28a745; /* Green line */
  max-width: 100px;
}

.team-header h2 {
  font-size: 2.25rem;
  font-weight: bold;
  color: #1a1a1a;
  margin: 0 15px;
}

.team-subtext {
  color: #555;
  margin-bottom: 50px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  font-size: 18px;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* changed from 3 */
  gap: 80px;
}


.member-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.hexagon-outer {
  width: 306px;
  height: 306px;
  background-color: #28a745; /* Green border */
  clip-path: polygon(
    50% 0%, 93% 25%, 93% 75%,
    50% 100%, 7% 75%, 7% 25%
  );
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hexagon-wrapper {
  width: 300px;
  height: 300px;
  background-color: white;
  clip-path: polygon(
    50% 0%, 93% 25%, 93% 75%,
    50% 100%, 7% 75%, 7% 25%
  );

  display: flex;
  align-items: center;
  justify-content: center;
}

.hexagon {
  width: 100%;
  height: 100%;
  clip-path: inherit;
  overflow: hidden;
}

.hexagon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}


/* Text Colors */
.text-cyan {
  color: #00bcd4;
}
.text-lime {
  color: #689f38;
}
.text-yellow {
  color: #f9a825;
}
.text-teal {
  color: #00796b;
}
.text-indigo {
  color: #3f51b5;
}


.member-name {
  font-weight: 600;
  font-size: 1.05rem;
  margin-bottom: 4px;
}

.member-title {
  font-size: 0.95rem;
  font-weight: 500;
  color: #444;
}

.member-description {
  font-size: 0.9rem;
  color: #555;
  max-width: 220px;
}

.hero-section1 {

  
  position: relative;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: rgb(45, 44, 44);
}

.hero-section1::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
 
  z-index: 1;
}

.hero-overlay {
  position: relative;
  z-index: 2;
  max-width: 800px;
  padding: 0 20px;

  display: flex;
  flex-direction: column; /* Stack vertically */
  align-items: center; /* Center horizontally */
  justify-content: center; /* Center vertically */
}

.hero-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.hero-subtitle {
  font-size: 1.25rem;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/pages/BoardMembers.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB,EAAE,eAAe;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,mBAAmB;EAC1D,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB,EAAE,iBAAiB;EAC5C;;;GAGC;EACD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB;;;GAGC;;EAED,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;;AAGA,gBAAgB;AAChB;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;;EAEf,aAAa;EACb,sBAAsB,EAAE,qBAAqB;EAC7C,mBAAmB,EAAE,wBAAwB;EAC7C,uBAAuB,EAAE,sBAAsB;AACjD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".team-section {\r\n  padding: 60px 20px;\r\n  text-align: center;\r\n  max-width: 1200px;\r\n  margin: auto;\r\n}\r\n\r\n.team-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 10px;\r\n  gap: 10px;\r\n}\r\n\r\n.team-header .line {\r\n  flex: 1;\r\n  height: 3px;\r\n  background-color: #28a745; /* Green line */\r\n  max-width: 100px;\r\n}\r\n\r\n.team-header h2 {\r\n  font-size: 2.25rem;\r\n  font-weight: bold;\r\n  color: #1a1a1a;\r\n  margin: 0 15px;\r\n}\r\n\r\n.team-subtext {\r\n  color: #555;\r\n  margin-bottom: 50px;\r\n  max-width: 700px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  font-size: 18px;\r\n}\r\n\r\n.team-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr); /* changed from 3 */\r\n  gap: 80px;\r\n}\r\n\r\n\r\n.member-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n.hexagon-outer {\r\n  width: 306px;\r\n  height: 306px;\r\n  background-color: #28a745; /* Green border */\r\n  clip-path: polygon(\r\n    50% 0%, 93% 25%, 93% 75%,\r\n    50% 100%, 7% 75%, 7% 25%\r\n  );\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.hexagon-wrapper {\r\n  width: 300px;\r\n  height: 300px;\r\n  background-color: white;\r\n  clip-path: polygon(\r\n    50% 0%, 93% 25%, 93% 75%,\r\n    50% 100%, 7% 75%, 7% 25%\r\n  );\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.hexagon {\r\n  width: 100%;\r\n  height: 100%;\r\n  clip-path: inherit;\r\n  overflow: hidden;\r\n}\r\n\r\n.hexagon img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n\r\n/* Text Colors */\r\n.text-cyan {\r\n  color: #00bcd4;\r\n}\r\n.text-lime {\r\n  color: #689f38;\r\n}\r\n.text-yellow {\r\n  color: #f9a825;\r\n}\r\n.text-teal {\r\n  color: #00796b;\r\n}\r\n.text-indigo {\r\n  color: #3f51b5;\r\n}\r\n\r\n\r\n.member-name {\r\n  font-weight: 600;\r\n  font-size: 1.05rem;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.member-title {\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n  color: #444;\r\n}\r\n\r\n.member-description {\r\n  font-size: 0.9rem;\r\n  color: #555;\r\n  max-width: 220px;\r\n}\r\n\r\n.hero-section1 {\r\n\r\n  \r\n  position: relative;\r\n  height: 400px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  color: rgb(45, 44, 44);\r\n}\r\n\r\n.hero-section1::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n \r\n  z-index: 1;\r\n}\r\n\r\n.hero-overlay {\r\n  position: relative;\r\n  z-index: 2;\r\n  max-width: 800px;\r\n  padding: 0 20px;\r\n\r\n  display: flex;\r\n  flex-direction: column; /* Stack vertically */\r\n  align-items: center; /* Center horizontally */\r\n  justify-content: center; /* Center vertically */\r\n}\r\n\r\n.hero-title {\r\n  font-size: 3rem;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.hero-subtitle {\r\n  font-size: 1.25rem;\r\n  font-weight: 400;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
